var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.subTitle)?_c('h2',{staticClass:"inrs-entete__sousTitle",domProps:{"innerHTML":_vm._s(_vm.subTitle)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }